

//---- components ---------
//---- mixins -------------
//---- services -----------
import NotificationService from "@/app/services/notification.js";
//---- other --------------
import User from "@/app/models/user.js";
//---- 3rd-parties --------
import { mapGetters } from "vuex";

export default {

  data() {
    return {
      user: new User("", ""),
      loading: false,
      err: [],
      timeOutCount: 0,
    };
  },

  computed: {
    ...mapGetters({
      backendUrl: "backendUrl",
      loginError: "auth/loginError",
    }),

    message() {
      const errorObject = this.loginError;
      const queryError = this.$route.query.error;
      
      if (!errorObject && !queryError) 
        return null;

      if (errorObject?.key == "Invalid name or password." || queryError == "CredentialsException")
        return this.$t("login.login-fail.$");

      if (errorObject?.key) {
          if (errorObject.key == "no-session")
            return null;
          else if (errorObject.key != "timedOut") // timedOut is handled differently 
            return this.$t(errorObject.key);
      }

      if (errorObject?.localizedMessage)
        return errorObject.localizedMessage;

      if (queryError)
        return queryError;
        
      return null;
    }, // end message
  }, // end computed

  methods: {
    // guide user with sign-in
    guideUserSignIn() {
        if (this.user.username == '')
            this.$refs.username.focus();
        else if (this.user.password == '')
            this.$refs.password.focus();
        else {
            const ke = new KeyboardEvent('keypress', {
                bubbles: true, cancelable: true, keyCode: 13
            });
            this.$refs.password.dispatchEvent(ke);
        }
    }, // end guideUserSignIn

    openIdConnect() {
      window.location.href = window.location.href.replaceAll(/\/[^/]*$/g, "/oidcLogin");
    }, // end openIdConnect

    forgetPassword() {
      this.safeRouterPush("/password-recovery");
    }, // end forgetPassword

    timeOutMessage() {
      if (this.timeOutCount == 0) {
        NotificationService.timeOutNotification(
          this.$t("sessionExpiredMessage")
        );
        this.timeOutCount = 1;
      }
    }, // end timeOutMessage

  } // end methods
}